@if (orientation() === 'vertical') {
  <nav class="text-primary gap-xs relative flex flex-col">
    @for (step of steps(); track step; let i = $index; let last = $last) {
      <div class="gap-xs flex" [class]="{ 'min-h-[80px]': !last }">
        <div class="gap-xxs flex flex-col items-center">
          <div
            class="size-md ring-primary flex items-center justify-center rounded-full ring-1"
            [class]="step.active() ? 'bg-primary text-white' : 'text-primary bg-white'"
          >
            <span>{{ i + 1 }}</span>
          </div>
          @if (!last) {
            <div class="border-primary w-0 flex-1 border-1"></div>
          }
        </div>
        <button
          class="paragraph-medium-semibold pb-lg -mx-xs px-xs -mt-xs pt-xs h-fit w-full items-start justify-start p-0 text-left whitespace-normal"
          (click)="goTo(i)"
          hlmBtn
          variant="ghost"
        >
          {{ step.label() }}
        </button>
      </div>
    }
  </nav>
} @else {
  <nav class="text-grey-10 gap-xs pb-lg relative flex">
    @for (step of steps(); track step; let i = $index; let last = $last) {
      <div class="gap-xs flex items-center">
        <button
          class="paragraph-medium-semibold px-xs h-fit w-full items-center justify-start text-left whitespace-normal"
          (click)="goTo(i)"
          hlmBtn
          variant="ghost"
        >
          @if (currentIndex() > i) {
            <div class="size-md bg-background-alternative flex items-center justify-center rounded-full">
              <ng-icon hlm size="sm" name="lucideCheck" />
            </div>
          } @else {
            <div
              class="size-md ring-primary flex items-center justify-center rounded-full ring-1"
              [class]="step.active() ? 'bg-primary text-white' : 'text-primary bg-white'"
            >
              <span>{{ i + 1 }}</span>
            </div>
          }
          <span>{{ step.label() }}</span>
        </button>
        @if (!last) {
          <div class="border-primary h-0 w-md flex-none border-t-1"></div>
        }
      </div>
    }
  </nav>
}
